<template>
  <div ref="widgetEl" class="turnstile-wrapper"></div>
</template>

<script>
const SCRIPT_ID = 'cf-turnstile-script'

export default {
  name: 'TurnstileWidget',
  props: {
    siteKey: { type: String, required: true }
  },
  emits: ['update:token'],
  data () {
    return { widgetId: null }
  },
  mounted () {
    if (!this.siteKey) return
    if (document.getElementById(SCRIPT_ID)) {
      // Script already loaded — render immediately
      this.$nextTick(() => this._render())
      return
    }
    const s = document.createElement('script')
    s.id = SCRIPT_ID
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
    s.async = true
    s.defer = true
    s.onload = () => this._render()
    document.head.appendChild(s)
  },
  beforeUnmount () {
    if (window.turnstile && this.widgetId !== null) {
      window.turnstile.remove(this.widgetId)
    }
  },
  methods: {
    _render () {
      if (!this.$refs.widgetEl || !window.turnstile) return
      this.widgetId = window.turnstile.render(this.$refs.widgetEl, {
        sitekey: this.siteKey,
        callback: (token) => this.$emit('update:token', token),
        'expired-callback': () => this.$emit('update:token', ''),
        'error-callback': () => this.$emit('update:token', '')
      })
    },
    reset () {
      if (window.turnstile && this.widgetId !== null) {
        window.turnstile.reset(this.widgetId)
        this.$emit('update:token', '')
      }
    }
  }
}
</script>

<style scoped>
.turnstile-wrapper {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}
</style>
